import React from "react";
import { useNavigate } from "react-router-dom";

function Header({ text }) {
  const navigate = useNavigate();

  return (
    <header className="header">
      <div className="header-con">
        <div>
          <h1>
            Every book is a  
            <br /> new <span>adventure.</span>
          </h1>
          <section style={{ display: "flex", gap: "10px" }}>
            <button onClick={() => navigate("/product/All Product")}>All Products</button>
            <button onClick={() => navigate("/product/All Product")}>
              Make Special Order
            </button>
          </section>
        </div>
      </div>
    </header>
  );
}

export default Header;
